module.exports = __webpack_public_path__ + "static/media/CamTerm3.04d4af7b.png";